import Link from "next/link";

import { t } from "@lingui/macro";
import { Button, Col, Modal, Result, Row } from "antd";

import { LoadingIndicator } from "components/loading";

const ExportModal = ({
  isExportingFile,
  setIsExportingFile,
  modalProps,
  setModalProps,
  view,
  controller,
  setController,
  exportData,
  setExportData,
  format,
  handleExport,
}: any) => {
  const shouldOpenDownloadInNewTab = ["pdf", "json", "html"].includes(format);

  return (
    <Modal
      width={420}
      open={modalProps?.[view]?.isModalVisible}
      afterClose={() => {
        if (exportData) {
          setExportData(null);
        }
        if (isExportingFile) {
          setIsExportingFile(false);
        }

        setController(new AbortController());
      }}
      onCancel={() => {
        if (isExportingFile && controller) {
          controller.abort("Cancelled by user");
        }

        setModalProps({ [view]: { isModalVisible: false } });
      }}
      footer={null}
    >
      {
        <Row justify="center">
          <Col>
            {exportData?.state === "completed" || exportData?.state === "failed" ? (
              <>
                {exportData?.state === "completed" && (
                  <Result
                    status="success"
                    title={t`Export is ready`}
                    extra={
                      <Link href={exportData?.content} target={shouldOpenDownloadInNewTab ? "_blank" : undefined}>
                        <Button type="primary" style={{ margin: "auto" }}>{t`Download`}</Button>
                      </Link>
                    }
                  />
                )}
                {exportData?.state === "failed" && (
                  <Result
                    status="error"
                    title={exportData?.message || t`Export failed, please try again`}
                    extra={
                      <Button
                        type="primary"
                        style={{ margin: "auto" }}
                        onClick={() => {
                          setExportData(null);
                          handleExport(format);
                        }}
                      >{t`Try again`}</Button>
                    }
                  />
                )}
              </>
            ) : (
              <Result
                style={{ paddingBottom: 0 }}
                status="info"
                title={t`Preparing export`}
                extra={<LoadingIndicator size="large" />}
              />
            )}
          </Col>
        </Row>
      }
    </Modal>
  );
};

export default ExportModal;
